export default "__VITE_ASSET__DqFgPpPQ__"